import React from "react";
import TaskBoard from "../../components/task/TaskBoard";

export default function TaskPage() {
  return <TaskBoard />;
}
